import { Button, Dropdown, Spin, Modal, Switch } from "antd";
import { useState } from "react";
import InfiniteTable from "../utils/InfiniteTable";
import {
  DeleteFilled,
  DownOutlined,
  EditFilled,
  UnlockFilled,
} from "@ant-design/icons";
import Toast from "../../helpers/Toast";
import { catchError } from "../../services/DaoService";
import { MonnaieService } from "../../services/MonnaieService";
import MonnaieEditForm from "./MonnaieEditForm";
import PropTypes from "prop-types";

const MonnaieList = ({ paginationData, setPaginationData, monnaies, setMonnaies, searchParams, init }) => {
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [updateModalVisible, setUpdateModalVisible] = useState(false);
  const [selectedMonnaie, setSelectedMonnaie] = useState(null);

  const loadMore = () => {
    if (paginationData?.next_page_url && !loadingMore) {
      setLoadingMore(true);
      MonnaieService
        .post(paginationData.next_page_url, searchParams)
        .then((response) => {
          if (!response) {
            return;
          }
          setPaginationData(response.data);
          setMonnaies(monnaies => [...monnaies, ...response.data.data]);
        })
        .catch((error) => {
          catchError(error);
        })
        .finally(() => {
          setLoadingMore(false);
        });
    }
  };
  const handleDelete = (idOrUid) => {
    setLoading(true);
    MonnaieService.getInstance()
      .remove(idOrUid)
      .then((response) => {
        Toast.success(response.message);
        setMonnaies((items) =>
          items.filter((item) => item.uid !== idOrUid)
        );
      })
      .catch((error) => {
        catchError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const openEditModal = (item) => {
    setSelectedMonnaie(item);
    setUpdateModalVisible(true);
  };

  const handleEnable = (monnaie) => {
    MonnaieService.getInstance()
      .enable(monnaie.uid)
      .then((response) => {
        Toast.success(response.message);
        init();
      })
      .catch((error) => {
        Toast.error(error.message);
      });
  };

  const handleUpdate = (item) => {
    setMonnaies(
      monnaies => monnaies.map((u) => (u.uid === item.uid ? item : u))
    );
    setSelectedMonnaie(null);
    setUpdateModalVisible(false);
  };

  const columns = [
    {
      title: "Nom",
      dataIndex: "nom",
      key: "nom",
      width: 150,
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      width: 150,
    },
    {
      title: "Symbole",
      dataIndex: "symbole",
      key: "symbole",
      width: 150,
    },
    {
      title: "Current",
      dataIndex: "current",
      key: "current",
      render: (current, item) => (
        <Switch checked={current} disabled={current} onChange={()=>handleEnable(item)} />
      ),
      width: 150,
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Dropdown
          menu={{
            items: [
              {
                key: 'edit',
                label: 'Modifier',
                icon: <EditFilled />,
                onClick: () => openEditModal(record)
              },
              !record.current && {
                key: 'toggle',
                label: 'Définir monnaie par défaut',
                icon: <UnlockFilled />,
                onClick: () => {
                  Modal.confirm({
                    title: `Voulez-vous définir cette monnaie comme monnaie par défaut ?`,
                    okText: 'Définir comme monnaie courrante',
                    cancelText: 'Annuler',
                    okType: record.enabled ? 'danger' : 'primary',
                    onOk: () => handleEnable(record)
                  });
                }
              },
              {
                key: 'delete',
                label: 'Supprimer',
                icon: <DeleteFilled />,
                danger: true,
                onClick: () => {
                  Modal.confirm({
                    title: `Voulez-vous vraiment procéder à la suppression ?`,
                    okText: 'Confirmer',
                    cancelText: 'Annuler',
                    okType: 'danger',
                    onOk: () => handleDelete(record.uid)
                  });
                }
              }
            ]
          }}
        >
          <Button>
            Actions <DownOutlined />
          </Button>
        </Dropdown>
      ),
      width: 120,
      fixed: 'right'
    },

  ];

  return (
    <>
      <Spin spinning={loading}>
        <InfiniteTable
          rowKey={"uid"}
          dataSource={monnaies}
          paginationData={paginationData}
          loadMore={loadMore}
          loading={loadingMore}
          columns={columns}
        />
      </Spin>
      {selectedMonnaie && (
        <MonnaieEditForm
          visible={updateModalVisible}
          uid={selectedMonnaie.uid}
          onUpdate={handleUpdate}
          onCancel={() => setUpdateModalVisible(false)}
        />
      )}
    </>
  );
}
export default MonnaieList;

MonnaieList.propTypes = {
  paginationData: PropTypes.object.isRequired,
  searchParams: PropTypes.object,
  setPaginationData: PropTypes.func.isRequired,
  monnaies: PropTypes.array.isRequired,
  setMonnaies: PropTypes.func.isRequired,
  init: PropTypes.func.isRequired,
};